import { render, staticRenderFns } from "./StrangerThings.vue?vue&type=template&id=48cba3e3&scoped=true&"
import script from "./StrangerThings.vue?vue&type=script&lang=js&"
export * from "./StrangerThings.vue?vue&type=script&lang=js&"
import style0 from "./StrangerThings.vue?vue&type=style&index=0&id=48cba3e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cba3e3",
  null
  
)

export default component.exports